// 150 → "150 zł", 13.5 → "13.50 zł"
export const formatZl = (value) =>
  `${Number(value || 0).toFixed(2).replace(/\.00$/, "")} zł`;

// plural(3, ["товар", "товара", "товаров"]) → "товара"
export const plural = (n, [one, few, many]) => {
  const m10 = n % 10;
  const m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return one;
  if (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) return few;
  return many;
};

export const PRODUCT_WORDS = ["товар", "товара", "товаров"];

// DRF віддає або масив, або сторінку { results: [...] }
export const toList = (data) =>
  Array.isArray(data) ? data : Array.isArray(data?.results) ? data.results : [];
